/**
 * Otter-Level (Aura v2, Okt 2026): sechs Wellen statt fuenf Titel.
 *
 * Die Namen gehoeren zu den Wellen-Bildern der Otter-Figur
 * (components/otter/OtterFigure.jsx, Zeichnungen in design/otter-art/).
 * Eigene kleine Datei ohne Importe, damit constants/auraLevels.js sie
 * einbinden kann, ohne den generierten Zeichnungs-Code mitzuladen.
 *
 * Die Punkte-Schwellen stehen NICHT hier: die liefert GET /aura/stats
 * (`thresholds`) pro Schule.
 */
export const OTTER_MAX_LEVEL = 6;

export const OTTER_LEVEL_NAMES = ['Tropfen', 'Welle', 'Strömung', 'Brandung', 'Meer', 'Ozean'];

/**
 * Level 1..6 oder null. Zahlen ueber 6 werden auf 6 gekappt, alles
 * Unbrauchbare (null, 0, Text) ergibt null.
 */
export const normalizeOtterLevel = (level) => {
  if (level === null || level === undefined || level === '') return null;
  const n = Number.parseInt(level, 10);
  if (!Number.isFinite(n) || n < 1) return null;
  return Math.min(n, OTTER_MAX_LEVEL);
};

export const getOtterLevelName = (level) => {
  const n = normalizeOtterLevel(level);
  return n ? OTTER_LEVEL_NAMES[n - 1] : null;
};
